import { render, staticRenderFns } from "./tableDesignModel.vue?vue&type=template&id=9bbe6318"
import script from "./tableDesignModel.vue?vue&type=script&lang=js"
export * from "./tableDesignModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bbe6318')) {
      api.createRecord('9bbe6318', component.options)
    } else {
      api.reload('9bbe6318', component.options)
    }
    module.hot.accept("./tableDesignModel.vue?vue&type=template&id=9bbe6318", function () {
      api.rerender('9bbe6318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/tableDesignModel.vue"
export default component.exports